module.exports = __webpack_public_path__ + "static/media/star-shooting.77968938.svg";